import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Enrollment } from './enrollment.model';
import { EnrollmentService } from './enrollment.service';
import { StudentService } from '../student/student.service';

@Injectable()
export class EnrollmentPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private enrollmentService: EnrollmentService,
        private studentService: StudentService

    ) { }

    open(component: Component, id?: number | any | any, studentId?: number): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.enrollmentService.find(id).subscribe(enrollment => {
                this.enrollmentModalRef(component, enrollment);
            });
        } else {
            let enrollment: Enrollment = new Enrollment();
            let today: Date = new Date();
            enrollment.validSince = {
                    year: today.getFullYear(),
                    month: today.getMonth() + 1,
                    day: today.getDate()
                };

            if (studentId) {
                // We are an enrollment a card for a specific student
                this.studentService.find(studentId).subscribe(student => {
                    enrollment.student = student;
                });
            }
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.enrollmentModalRef(component, enrollment);
            });
        }
    }

    enrollmentModalRef(component: Component, enrollment: Enrollment): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.enrollment = enrollment;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/enrollment/enrollment-popup.service.ts